import { DRM_URL_TYPE } from '../../../config/constants';
import { appConfig } from '../../../config/app.config';
import user from '../../../helpers/user';
import browser from '../../../helpers/browser';

const getSafariDRMConfig = () => {
    return {
        immediateLicenseRequest: false,
        fairplay: {
            LA_URL: user.getDRMLicense(DRM_URL_TYPE.FAIRPLAY),
            certificateURL: appConfig.bitMovinDRMConfiguration.certificateURL,
            licenseResponseType: appConfig.bitMovinDRMConfiguration.licenseResponseType,
            useUint16InitData: appConfig.bitMovinDRMConfiguration.useUint16InitData,
            prepareMessage: (event: any, session: any) => {
                return 'spc=' + encodeURIComponent(event.messageBase64Encoded) + '&assetId=' + session.contentId;
            },
            prepareContentId: (contentId: string) => contentId.replace(/^.*skd:\/\//, ''),
            prepareLicense: (data: any) => data.ckc,
        },
    };
};

const getOtherDRMConfig = () => {
    return {
        preferredKeySystems: ['widevine', 'playready'],
        playready: {
            LA_URL: user.getDRMLicense(DRM_URL_TYPE.PLAYREADY),
        },
        widevine: {
            LA_URL: user.getDRMLicense(DRM_URL_TYPE.WIDEVINE),
        },
    };
};

export const getDRMConfig = () => {
    return browser.isSafari() ? getSafariDRMConfig() : getOtherDRMConfig();
};
